var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H24C27.3137 0 30 2.68629 30 6V24C30 27.3137 27.3137 30 24 30H6C2.68629 30 0 27.3137 0 24V6Z",
    fill: "#1A86E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9688 13.2812C21.8438 11.4688 20.3438 10 18.5 10C18.25 10 18 10.0312 17.7812 10.0938C16.7812 8.84375 15.25 8 13.5 8C10.8438 8 8.625 9.875 8.09375 12.375C6.21875 13.1562 5 14.9688 5 17C5 19.7812 7.21875 22 10 22H20.5C22.9688 22 25 20 25 17.5C25 15.5938 23.75 13.9062 21.9688 13.2812ZM20.5 20.5H10C8.0625 20.5 6.5 18.9375 6.5 17C6.5 15.25 7.78125 13.7812 9.5 13.5625V13.5C9.5 11.3125 11.2812 9.5 13.5 9.5C15.1562 9.5 16.5938 10.5312 17.1875 12C17.5312 11.6875 18 11.5 18.5 11.5C19.5938 11.5 20.5 12.4062 20.5 13.5C20.5 13.875 20.375 14.2188 20.2188 14.5312C20.3125 14.5312 20.4062 14.5 20.5 14.5C22.1562 14.5 23.5 15.8438 23.5 17.5C23.5 19.1562 22.1562 20.5 20.5 20.5ZM16.9688 15C16.8125 14.8438 16.5938 14.8438 16.4375 15L14.75 16.75V12.375C14.75 12.1875 14.5625 12 14.375 12H13.625C13.4062 12 13.25 12.1875 13.25 12.375V16.75L11.5312 15C11.375 14.8438 11.1562 14.8438 11 15L10.4688 15.5312C10.3125 15.6875 10.3125 15.9062 10.4688 16.0625L13.7188 19.3125C13.875 19.4688 14.0938 19.4688 14.25 19.3125L17.5 16.0625C17.6562 15.9062 17.6562 15.6875 17.5 15.5312L16.9688 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstall);
export default __webpack_public_path__ + "static/media/install.2e7d137b.svg";
export { ForwardRef as ReactComponent };